import React from 'react';
import GuidedRemovalDecisionScreen from './GuidedRemovalDecisionScreen';

function RemovalDecisionStep({ currentService, selectedCenter, onRemovalDecision, onBack }) {
  return (
    <div className="step-content">
      <GuidedRemovalDecisionScreen
        serviceName={currentService?.name}
        onDecide={onRemovalDecision}
        onBack={onBack}
      />
    </div>
  );
}

export default RemovalDecisionStep;
